// extracted by mini-css-extract-plugin
export default {"root":"CaseStudyCard_root__Gsw-c","title":"CaseStudyCard_title__UVU48 h3","postDate":"CaseStudyCard_postDate__YMEg2","square":"CaseStudyCard_square__gtFc0"};